import { z } from 'zod'

/** 使用者資訊 Schema */
export const userProfileSchema = z.object({
  /** Bear token */
  token: z.string(),
  /** refresh token */
  refreshToken: z.string().optional(),
  /** 員工編號	 */
  uid: z.string(),
  /** 姓名 */
  name: z.string().optional(),
  /** email */
  email: z.string().optional(),
  /** 語系 */
  lang: z.string().optional()
})

/** 使用者資訊 */
export interface UserProfile extends z.infer<typeof userProfileSchema> {}
